// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

import graph from 'app/lib/graph';

class DeleteUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    if (this.props.confirmation) {
      return this.setState({ modal: true });
    }
    this.props.onClick();
  };

  handleConfirmation = async (type) => {
    const user = this.props.user;
    const uuid = user?.get?.('uuid') || user.uuid;

    const res = await graph(
      'mutation  SetUserType($uuid: ID!, $type: String!) { setUserType(uuid: $uuid, type: $type) { type } }',
      {
        uuid,
        type
      }
    );

    if (res.data?.setUserType) {
      this.props.onSubmit(res.data.setUserType);
    }

    this.handleClose();
  };

  renderTriggerButton(actionLabel) {
    return (
      <Button
        flat
        secondary
        tabIndex={-1}
        label={actionLabel}
        onClick={this.handleClick}
        style={{ float: 'left' }}
      />
    );
  }

  render() {
    const currentType = this.props.user?.get?.('type') || this.props.user.type;
    const actionLabel = 'Skift bruger type';

    if (this.props.confirmation) {
      const actions = [
        <Button
          key="cancel"
          secondary
          flat
          label={this.props.i18n('Cancel')}
          onClick={this.handleClose}
          style={{ marginLeft: '12px' }}
        />,
        <Button
          key="setVA"
          primary
          autoFocus
          label={this.props.i18n('Set to VA')}
          onClick={() => this.handleConfirmation('VA')}
          style={{ marginLeft: '12px' }}
        />,
        <Button
          key="setPERSONAL"
          primary
          autoFocus
          label={this.props.i18n('Set to PERSONAL')}
          onClick={() => this.handleConfirmation('PERSONAL')}
          style={{ marginLeft: '12px' }}
        />,
        <Button
          key="setBUSINESS"
          primary
          autoFocus
          label={this.props.i18n('Set to BUSINESS')}
          onClick={() => this.handleConfirmation('BUSINESS')}
          style={{ marginLeft: '12px' }}
        />
      ];

      return (
        <div>
          {this.state.modal ? (
            <Dialog
              open
              fullWidth
              fullScreen={this.props.fullScreen}
              onClose={this.handleClose}
              className="dialog-common"
            >
              <DialogTitle>{actionLabel}</DialogTitle>
              <DialogContent>
                {'Nuværende bruger type er ' + currentType}
              </DialogContent>
              <DialogContent>
                {'Vælg typen som brugeren skal opdateres til'}
              </DialogContent>
              <DialogActions>{actions}</DialogActions>
            </Dialog>
          ) : null}
          {this.renderTriggerButton(actionLabel)}
        </div>
      );
    }

    return this.renderTriggerButton(actionLabel);
  }
}

const DeleteUserI18n = i18n(DeleteUser);

function DeleteUserWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <DeleteUserI18n {...props} fullScreen={fullScreen} />;
}

export default DeleteUserWithMobileDialog;